<script lang="ts">
	import { page } from '$app/stores';
	import '../app.css';
	import logo from '$lib/assets/images/logo.webp';
	import { STATES, getStateNameBySlug } from '$lib/states';
	import {
		Navbar,
		NavBrand,
		NavUl,
		NavLi,
		NavHamburger,
		Dropdown,
		DropdownItem,
		Button,
		Footer,
		FooterLinkGroup,
		FooterLink,
		FooterCopyright
	} from 'flowbite-svelte';
	import { ChevronDownOutline } from 'flowbite-svelte-icons';

	$: activeUrl = $page.url.pathname;
	$: slug = activeUrl.match(/\/state\/([a-z-]+)/);
</script>

<svelte:head>
	<title>
		{$page.data?.meta?.title || 'Secrets to Winning Scratchoffs - Dr. Lotto'}</title
	>
	<meta
		name="description"
		content={$page.data?.meta?.description || 'Win more scratchoffs with Doctor Lotto'}
	/>
	<meta
		name="keywords"
		content="
		{$page?.data?.meta?.keywords ||
			'scratchoffs, scratchers, scratch tickets, scratch off tickets, scratch off games'}"
	/>
	<meta name="author" content="Dr. Lotto" />
	<meta name="robots" content="index, follow" />
	<meta
		property="og:title"
		content={$page.data?.meta?.title || 'Secrets to Winning Scratchoffs - Dr. Lotto'}
	/>
	<meta
		property="og:description"
		content={$page.data?.meta?.description || 'Win more scratchoffs with Doctor Lotto'}
	/>
	<meta property="og:image" content="https://dr-lotto.com/assets/images/logo.png" />
	<meta property="og:url" content="https://dr-lotto.com" />
	<meta property="og:type" content="website" />
</svelte:head>

<div class="flex flex-col min-h-screen">
	<Navbar class="bg-dark-900">
		<NavBrand class="w-24" href="/">
			<img src={logo} class="h-24 w-24" alt="Dr. Lotto Logo" />
		</NavBrand>

		<div class="flex-1 flex justify-center">
			<Button class="w-3/4 md:w-1/2 text-center cursor-pointer">
				{#if slug}
					{getStateNameBySlug(slug[1])}
				{:else}
					Choose a State
				{/if}
				<ChevronDownOutline class="w-6 h-6 ms-2 text-secondary-800 dark:text-white inline" />
			</Button>
			{#if STATES}
				<Dropdown {activeUrl} size="lg" class="w-80 h-64 z-20 overflow-y-auto">
					{#each STATES as state}
						<DropdownItem href={`/state/${state.slug}`}>{state.name}</DropdownItem>
					{/each}
				</Dropdown>
			{/if}
		</div>

		<NavHamburger />
		<NavUl classUl="bg-dark-700">
			<NavLi class="text-primary-100" href="/">Home</NavLi>
			<NavLi class="text-primary-100" href="/articles">Learn</NavLi>
			<NavLi class="text-primary-100" href="/faq">FAQ</NavLi>
		</NavUl>
	</Navbar>
	<main class="md:container mx-auto flex-grow p-4 md:p-8">
		<slot />
	</main>

	<Footer class="bg-dark-900">
		<div class="sm:flex sm:items-center sm:justify-between p-8">
			<FooterCopyright href="/" by="Dr. Lotto" year={2024} />
			<FooterLinkGroup
				ulClass="flex flex-wrap items-center mt-3 text-sm text-primary-100 dark:text-gray-400 sm:mt-0"
			>
				<FooterLink
					href="https://app.termly.io/document/privacy-policy/a3144902-f46d-42ce-8d01-e5637d3c720b"
					>Privacy Policy</FooterLink
				>
				<FooterLink href="mailto:support@dr-lotto.com">Contact</FooterLink>
			</FooterLinkGroup>
		</div>
	</Footer>
</div>

<style lang="postcss">
	:global(*) {
		box-sizing: border-box;
	}
</style>
